<template>
  <div>
    <vs-card class="mt-6 mb-base">

    </vs-card>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      id: this.$route.params.id,
      operation: null,
      searching: true,
      found: null,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {}
    }
  },
  created () {
    this.fetchForm()
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.raf.length
    }
  },
  mounted () {
    this.isMounted = true
  },
  methods: {
    fetchForm () {
      this.$http.get('/api/staging/form/' + this.id)
        .then(({ data }) => {
          this.form = data.form
          if (data.form.center.WORKCENTERNAME) this.operation = data.form.center.WORKCENTERNAME.split(' ')[0].toLowerCase()
          if (this.operation) this.$router.replace({ path: '/form/' + this.id + '/' + this.operation })
          else {
            this.searching = false
            this.found = false
          }
        })
        .catch(e => {
          this.$vs.notify({
            title: 'Failed to fetch form data',
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
            timer: 1500
          })
        })
    },
    addNewData () {
      this.sidebarData = {}
      // this.toggleDataSidebar(true)
    },
    editData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      // this.toggleDataSidebar(true)
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    moment (time) {
      return moment(time)
    }
  }
}
</script>

<style>
.vs-card--content {
  padding: 0px;
}
.vs-table--search {
  padding-right: 20px !important;
}
</style>
